"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSERT = ASSERT;
exports.DEBUG = DEBUG;
exports.DEBUG_MODE_ON = DEBUG_MODE_ON;
function ASSERT(f, t) {
    if (process.env.NODE_ENV !== 'production') {
        if (!f() && t)
            console.error(t);
    }
}
let DEBUG_MODE = false;
function DEBUG(f) {
    if (DEBUG_MODE)
        f();
}
function DEBUG_MODE_ON(on) {
    DEBUG_MODE = on;
}
